export enum DevModeStatus {
  Loading,
  Disabled,
  On,
  Error,
}
